import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { AutoCompleteRemoto } from '../..';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function getLabel(value, defaultValue) {
  if (value) {
    switch (value.codigo.length) {
      case 2:
        return 'Capítulo';
      case 4:
        return 'Posição';
      case 5:
        return 'SubPosição 1';
      case 6:
        return 'SubPosição 2';
      case 7:
        return 'Item';
      case 8:
        return 'SubItem';

      default:
        return '';
    }
  }

  return defaultValue;
}

function getNcm(dados) {
  if (dados) {
    if (dados.subitem) {
      if (dados.subitem.codigo.length === 8) {
        return dados.subitem.codigo;
      }
    }

    if (dados.item) {
      if (dados.item.codigo.length === 8) {
        return dados.item.codigo;
      }
    }

    if (dados.subposicao2) {
      if (dados.subposicao2.codigo.length === 8) {
        return dados.subposicao2.codigo;
      }
    }

    if (dados.subposicao1) {
      if (dados.subposicao1.codigo.length === 8) {
        return dados.subposicao1.codigo;
      }
    }

    if (dados.posicao) {
      if (dados.posicao.codigo.length === 8) {
        return dados.posicao.codigo;
      }
    }

    if (dados.capitulo) {
      if (dados.capitulo.codigo.length === 8) {
        return dados.capitulo.codigo;
      }
    }
  }

  return '';
}

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, handleSalvar }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    /*   const [capitulo, setCapitulo] = useState(null);
  const [posicao, setPosicao] = useState(null);
  const [subposicao1, setSubosicao1] = useState(null);
  const [subposicao2, setSubosicao2] = useState(null);
  const [item, setItem] = useState(null);
  const [subitem, setSubitem] = useState(null); */

    const classes = useStyles({ cor: '#009FD4' });

    const [dados, setDados] = useState({
      capitulo: null,
      posicao: null,
      subposicao1: null,
      subposicao2: null,
      item: null,
      subitem: null,
    });

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    async function handleSalvarLocal() {
      setOpen(false);
      handleSalvar(ncm);
    }

    useImperativeHandle(ref, () => ({
      handleOpen() {
        setOpen(true);
        setDados({
          capitulo: null,
          posicao: null,
          subposicao1: null,
          subposicao2: null,
          item: null,
          subitem: null,
        });
      },
    }));

    const ncm = getNcm(dados);

    function validateNcm() {
      let error = '';
      if (!ncm) {
        error = ' NCM ainda falta ser selecionado!';
      }
      return error;
    }

    function getErros() {
      const errosOld = [''];
      errosOld[0] = validateNcm();
      return errosOld;
    }

    const erros = getErros();

    function hasError() {
      for (let i = 0; i < erros.length; i += 1) {
        if (erros[i] !== '') return true;
      }
      return false;
    }

    const erroExistente = hasError();

    function updateCapitulo(value) {
      setDados({
        capitulo: value,
        posicao: null,
        subposicao1: null,
        subposicao2: null,
        item: null,
        subitem: null,
      });
    }

    function updatePosicao(value) {
      setDados({
        capitulo: dados.capitulo,
        posicao: value,
        subposicao1: null,
        subposicao2: null,
        item: null,
        subitem: null,
      });
    }

    function updateSubposicao1(value) {
      setDados({
        capitulo: dados.capitulo,
        posicao: dados.posicao,
        subposicao1: value,
        subposicao2: null,
        item: null,
        subitem: null,
      });
    }

    function updateSubposicao2(value) {
      setDados({
        capitulo: dados.capitulo,
        posicao: dados.posicao,
        subposicao1: dados.subposicao1,
        subposicao2: value,
        item: null,
        subitem: null,
      });
    }

    function updateItem(value) {
      setDados({
        capitulo: dados.capitulo,
        posicao: dados.posicao,
        subposicao1: dados.subposicao1,
        subposicao2: dados.subposicao2,
        item: value,
        subitem: null,
      });
    }

    function updateSubitem(value) {
      setDados({
        capitulo: dados.capitulo,
        posicao: dados.posicao,
        subposicao1: dados.subposicao1,
        subposicao2: dados.subposicao2,
        item: dados.item,
        subitem: value,
      });
    }

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="lg"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#009FD4', color: 'white' }}
          >
            Seleção do NCM
          </DialogTitle>
          <DialogContent
            style={{
              padding: '10px 36px 20px',
              margin: '0',
            }}
          >
            <div>
              <Box
                flex={1}
                mt="20px"
                style={{
                  display: 'flex',
                }}
              >
                <Box
                  display="flex"
                  css={{
                    backgroundColor: 'white',
                    opacity: '0.75',
                    padding: '0px 10px',
                    flexDirection: 'column',
                  }}
                  flex={1}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    flex={1}
                    style={{
                      gap: '10px',
                    }}
                  >
                    <AutoCompleteRemoto
                      id="fornecedor"
                      name="fornecedor"
                      label="Capitulo"
                      value={dados.capitulo}
                      onChange={(value) => {
                        updateCapitulo(value);
                      }}
                      handleKey={(keyCode, keyName) => {}}
                      handleEnter={() => {}}
                      resource="ncm-items"
                      campo="descricao"
                      toString={false}
                      style={{}}
                      fullwidth={false}
                      filters={{
                        //nivel: NIVEL_CODIGO_NCM_CAPITULO,
                        codigo_pai: null,
                      }}
                      getOptionSelected={(option, value) =>
                        option.descricao === value.descricao
                      }
                      getOptionLabel={(option) =>
                        `${
                          option.descricao
                            ? `${option.descricao} (${option.codigo})`
                            : ''
                        }`
                      }
                      perPage={50}
                    />
                  </Box>
                  {dados.capitulo ? (
                    dados.capitulo.codigo.length < 8 ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        flex={1}
                        style={{
                          gap: '10px',
                        }}
                      >
                        <AutoCompleteRemoto
                          id="fornecedor"
                          name="fornecedor"
                          label={getLabel(dados.posicao, 'Posição')}
                          value={dados.posicao}
                          onChange={(value) => {
                            updatePosicao(value);
                          }}
                          handleKey={(keyCode, keyName) => {}}
                          handleEnter={() => {}}
                          resource="ncm-items"
                          campo="descricao"
                          toString={false}
                          style={{}}
                          fullwidth={false}
                          filters={
                            dados.capitulo
                              ? {
                                  codigo_pai: dados.capitulo.codigo,
                                }
                              : {}
                          }
                          getOptionSelected={(option, value) =>
                            option.descricao === value.descricao
                          }
                          getOptionLabel={(option) =>
                            `${
                              option.descricao
                                ? `${option.descricao} (${option.codigo})`
                                : ''
                            }`
                          }
                          perPage={50}
                        />
                      </Box>
                    ) : null
                  ) : null}
                  {dados.posicao ? (
                    dados.posicao.codigo.length < 8 ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        flex={1}
                        style={{
                          gap: '10px',
                        }}
                      >
                        <AutoCompleteRemoto
                          id="fornecedor"
                          name="fornecedor"
                          label={getLabel(dados.subposicao1, 'Subposição 1')}
                          value={dados.subposicao1}
                          onChange={(value) => {
                            updateSubposicao1(value);
                          }}
                          handleKey={(keyCode, keyName) => {}}
                          handleEnter={() => {}}
                          resource="ncm-items"
                          campo="descricao"
                          toString={false}
                          style={{}}
                          fullwidth={false}
                          filters={
                            dados.posicao
                              ? {
                                  codigo_pai: dados.posicao.codigo,
                                }
                              : {}
                          }
                          getOptionSelected={(option, value) =>
                            option.descricao === value.descricao
                          }
                          getOptionLabel={(option) =>
                            `${
                              option.descricao
                                ? `${option.descricao} (${option.codigo})`
                                : ''
                            }`
                          }
                          perPage={50}
                        />
                      </Box>
                    ) : null
                  ) : null}
                  {dados.subposicao1 ? (
                    dados.subposicao1.codigo.length < 8 ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        flex={1}
                        style={{
                          gap: '10px',
                        }}
                      >
                        <AutoCompleteRemoto
                          id="fornecedor"
                          name="fornecedor"
                          label={getLabel(dados.subposicao2, 'Subposição 2')}
                          value={dados.subposicao2}
                          onChange={(value) => {
                            updateSubposicao2(value);
                          }}
                          handleKey={(keyCode, keyName) => {}}
                          handleEnter={() => {}}
                          resource="ncm-items"
                          campo="descricao"
                          toString={false}
                          style={{}}
                          fullwidth={false}
                          filters={
                            dados.subposicao1
                              ? {
                                  codigo_pai: dados.subposicao1.codigo,
                                }
                              : {}
                          }
                          getOptionSelected={(option, value) =>
                            option.descricao === value.descricao
                          }
                          getOptionLabel={(option) =>
                            `${
                              option.descricao
                                ? `${option.descricao} (${option.codigo})`
                                : ''
                            }`
                          }
                          perPage={50}
                        />
                      </Box>
                    ) : null
                  ) : null}

                  {dados.subposicao2 ? (
                    dados.subposicao2.codigo.length < 8 ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        flex={1}
                        style={{
                          gap: '10px',
                        }}
                      >
                        <AutoCompleteRemoto
                          id="fornecedor"
                          name="fornecedor"
                          label={getLabel(dados.item, 'Item')}
                          value={dados.item}
                          onChange={(value) => {
                            updateItem(value);
                          }}
                          handleKey={(keyCode, keyName) => {}}
                          handleEnter={() => {}}
                          resource="ncm-items"
                          campo="descricao"
                          toString={false}
                          style={{}}
                          fullwidth={false}
                          filters={
                            dados.subposicao2
                              ? {
                                  codigo_pai: dados.subposicao2.codigo,
                                }
                              : {}
                          }
                          getOptionSelected={(option, value) =>
                            option.descricao === value.descricao
                          }
                          getOptionLabel={(option) =>
                            `${
                              option.descricao
                                ? `${option.descricao} (${option.codigo})`
                                : ''
                            }`
                          }
                          perPage={50}
                        />
                      </Box>
                    ) : null
                  ) : null}
                  {dados.item ? (
                    dados.item.codigo.length < 8 ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        flex={1}
                        style={{
                          gap: '10px',
                        }}
                      >
                        <AutoCompleteRemoto
                          id="fornecedor"
                          name="fornecedor"
                          label={getLabel(dados.subitem, 'SubItem')}
                          value={dados.subitem}
                          onChange={(value) => {
                            updateSubitem(value);
                          }}
                          handleKey={(keyCode, keyName) => {}}
                          handleEnter={() => {}}
                          resource="ncm-items"
                          campo="descricao"
                          toString={false}
                          style={{}}
                          fullwidth={false}
                          filters={
                            dados.item
                              ? {
                                  codigo_pai: dados.item.codigo,
                                }
                              : {}
                          }
                          getOptionSelected={(option, value) =>
                            option.descricao === value.descricao
                          }
                          getOptionLabel={(option) =>
                            `${
                              option.descricao
                                ? `${option.descricao} (${option.codigo})`
                                : ''
                            }`
                          }
                          perPage={50}
                        />
                      </Box>
                    ) : null
                  ) : null}
                </Box>
              </Box>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: '0px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              Fechar
            </Button>
            <div className={classes.wrapper}>
              <Button
                onClick={handleSalvarLocal}
                classes={{
                  root: classes.btnAtions,
                  disabled: classes.btnAtionsDisabled,
                }}
                disabled={erroExistente}
                variant="contained"
                color="primary"
              >
                Salvar
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
